module.exports = __webpack_public_path__ + "static/4i-7beffbacbbde86423a7ee771f31c1626.woff";